/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

// storageUtils.js
export function setRealmId(value) {
    sessionStorage.setItem('realmId', value);
    window.dispatchEvent(new Event('realmIdUpdate'));
  }
  
  export function clearRealmId() {
    sessionStorage.removeItem('realmId');
    window.dispatchEvent(new Event('realmIdUpdate'));
  }
  